import { OverTimeOrderingOption, OverTimeLayoutOption } from './constants';

export { OverTimeOrderingOption, OverTimeLayoutOption };

interface HasTopLevelParent {
  topLevelParent?: string;
}

export const sortProductsForRibbons = ({
  productA,
  productB,
  sortingOrder,
}: {
  productA: HasTopLevelParent;
  productB: HasTopLevelParent;
  sortingOrder: string[];
}) => {
  const productAIndex = productA.topLevelParent
    ? sortingOrder.indexOf(productA.topLevelParent)
    : 0;
  const productBIndex = productB.topLevelParent
    ? sortingOrder.indexOf(productB.topLevelParent)
    : 0;

  return productAIndex - productBIndex;
};

export const sortLocationsForRibbons = ({
  locationA,
  locationB,
  sortingOrder,
}: {
  locationA: HasTopLevelParent;
  locationB: HasTopLevelParent;
  sortingOrder: string[];
}) => {
  const locationAIndex = locationA.topLevelParent
    ? sortingOrder.indexOf(locationA.topLevelParent)
    : 0;
  const locationBIndex = locationB.topLevelParent
    ? sortingOrder.indexOf(locationB.topLevelParent)
    : 0;

  return locationAIndex - locationBIndex;
};
